export default __webpack_public_path__ + "static/media/DickCrucified.fddddbbe.png";